// src/pages/Contact.jsx
import SectionTitle from '../components/common/SectionTitle';
import contactBg from '../Assets/TeamandOthers/Reception.webp';
import contactBg2 from '../Assets/TeamandOthers/Contactimg.jpg'
// Suggestion: Import a high-quality hospital exterior or interior image
// import hospitalImage from '../Assets/TeamandOthers/HospitalBuilding.webp'; 
import { Helmet } from "react-helmet";
const branches = [
  {
    city: "VIJAYAWADA",
    name: "Dr. Sridhar International Dental Hospital",
    address: "Vijaya Talkies Centre, Eluru Rd, Vijayatakies Centre, Governor Peta, Vijayawada, Andhra Pradesh 520002",
    email: "dr.sridhardental@gmail.com",
    phones: ["0866-2432011", "2435011", "9490948081"],
    timings: [
      { day: "Mon - Sat", hours: "10:00 AM – 8:00 PM" },
      { day: "Sunday", hours: "10:00 AM – 1:00 PM" }
    ],
    extraContacts: [
      { label: "EHS & ABS Enquiry", name: "Samuel John", phone: "9553831831" },
      { label: "Emergency (Natraj)", phone: "9963036436" },
      { label: "Emergency (Eswar Reddy)", phone: "9705650999" },
    ],
    mapUrl: "https://maps.app.goo.gl/UQxANYVxNfxVxTKG6",
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1200!2d80.6299887!3d16.5141267!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35e54988ce8c69%3A0x4bf21cdd292f130a!2sDr.%20Sridhar%20International%20Dental%20Hospital!5e0!3m2!1sen!2sin!4v1710580000000!5m2!1sen!2sin"
  },
  {
    city: "KPHB HYDERABAD",
    name: "Dr. Sridhar International Dental Hospital",
    address: "MIG 70, 2nd Floor, Above ICICI Bank Building Hi-Tech City Road Landmark: Opposite JNTU University & Above Indian Bank KPHB, Hyderabad.Telangana 500072",
    email: "jntu@sridhardental.com",
    phones: ["8121 222 666", "8121 222 888", "812 59 22 666"],
    timings: [
      { day: "Mon - Sat", hours: "10:00 AM – 2:00 PM, 4:30 PM – 8:30 PM" },
      { day: "Sunday", hours: "10:00 AM – 2:00 PM" }
    ],
    mapUrl: "https://www.google.com/maps/dir//Dr.+Sridhar+International+Dental+Hospital+KPHB",
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1200!2d78.3915832!3d17.4947698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91f28f3ef469%3A0x8633114da92b8325!2sDr.%20Sridhar%20International%20Dental%20Hospital!5e0!3m2!1sen!2sin!4v1710580000000!5m2!1sen!2sin"
  },
  {
    city: "AMEERPET",
    name: "Dr. Sridhar International Dental Hospital",
    address: "1st floor, above darlies ice cream, opp. Big Bazaar Road, Pratap Nagar, Punjagutta Officers Colony, Ameerpet, Hyderabad, Telangana 500082",
    email: "ameerpet@sridhardental.com",
    phones: ["040-66611166", "23417265", "81216 66111"],
    timings: [
      { day: "Mon - Sat", hours: "10:00 AM – 9:00 PM" },
      { day: "Sunday", hours: "10:00 AM – 2:00 PM" }
    ],
    mapUrl: "https://www.google.com/maps/dir//Dr.+Sridhar+International+Dental+Hospital+Ameerpet",
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1200!2d78.4483582!3d17.4305799!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb90cb94d473ad%3A0x9cddc6e1849a4df6!2sDr.%20Sridhar%20International%20Dental%20Hospital!5e0!3m2!1sen!2sin!4v1710580000000!5m2!1sen!2sin"
  },
  {
    city: "NALLAGANDLA (BHEL)",
    name: "Dr. Sridhar International Dental Hospital",
    address: "1st Floor, T junction, Plot 230, VMS Arcade, above Apollo Pharmacy, Nallagandla, Hyderabad, Telangana 500073",
    email: "nallagandla@sridhardental.com",
    phones: ["954 202 7700"],
    timings: [
      { day: "Mon - Sat", hours: "10:00 AM – 2:00 PM, 4:30 PM – 8:30 PM" },
      { day: "Sunday", hours: "10:00 AM – 2:00 PM,  4:30 PM – 7:00 PM" }
    ],
    mapUrl: "https://www.google.com/maps/dir//Dr.+Sridhar+International+Dental+Hospital+Nallagandla",
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1200!2d78.3139887!3d17.4789164!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb90cbc6b4a72f%3A0x9904bc3dd6d6798f!2sDr.%20Sridhar%20International%20Dental%20Hospital!5e0!3m2!1sen!2sin!4v1710580000000!5m2!1sen!2sin"
  }
];

const Contact = () => {
  return (
    <main className="min-h-screen bg-gray-50">
      <Helmet>
  <title>Contact Dentist Vijayawada | Book Now</title>
  <meta name="description" content="Contact Dr Sridhar dental hospital Vijayawada to book appointment for expert dental care and treatments today." />
  <meta name="keywords" content="contact dentist Vijayawada, appointment" />
  <meta name="author" content="Dr Sridhar Dental" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://sridhardental.com/contact" />
</Helmet>
      {/* Hero Section */}
      <section className="relative text-white py-24 md:py-32 bg-cover bg-center" style={{ backgroundImage: `url(${contactBg})` }}>
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-black/60"></div>
        <div className="relative container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-6xl font-extrabold mb-4">Contact Us</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto leading-relaxed">
            World-class dental healthcare across Hyderabad and Vijayawada. Reach out to your nearest branch today.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="container mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            
            {/* Image Section (Replaces the Form) */}
            <div className="lg:col-span-5">
              <div className="bg-white p-3 md:p-4 rounded-[2.5rem] shadow-2xl border border-gray-100 sticky top-24 overflow-hidden group">
                <div className="relative h-[500px] md:h-[650px] overflow-hidden rounded-[2rem]">
                  <img 
                    src={contactBg2} // Using reception image as placeholder, replace with a vertical hospital image if available
                    alt="Dr. Sridhar International Dental Hospital" 
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  {/* Optional Overlay Text */}
                  <div className="absolute bottom-0 inset-x-0 p-8 bg-gradient-to-t from-black/80 to-transparent text-white">
                    <h2 className="text-2xl font-bold mb-2">Advanced Care</h2>
                    <p className="text-sm text-gray-200">State-of-the-art facilities designed for your comfort and safety.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Branches Section */}
            <div className="lg:col-span-7 space-y-10">
              {branches.map((branch, index) => (
                <div key={index} className="bg-white rounded-[2rem] overflow-hidden shadow-xl border border-gray-100 flex flex-col group hover:shadow-2xl transition-all duration-300">
                  
                  <a 
                    href={branch.mapUrl} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="w-full h-64 bg-gray-200 relative block cursor-pointer group/map"
                  >
                    <iframe
                      title={`${branch.city} map`}
                      src={branch.embedUrl}
                      className="w-full h-full border-0 pointer-events-none"
                      allowFullScreen=""
                      loading="lazy"
                    ></iframe>
                    <div className="absolute inset-0 bg-blue-900/10 opacity-0 group-hover/map:opacity-100 transition-opacity flex items-center justify-center">
                      <span className="bg-white text-blue-600 px-4 py-2 rounded-full font-bold text-sm shadow-lg">View on Google Maps</span>
                    </div>
                  </a>

                  <div className="p-8 md:p-10">
                    <div className="flex flex-col md:flex-row justify-between items-start gap-4 mb-6">
                      <div>
                        <span className="inline-block px-4 py-1 bg-blue-50 text-blue-600 text-xs font-bold rounded-full uppercase tracking-widest mb-2">
                          {branch.city} Branch
                        </span>
                        <h3 className="text-2xl font-bold text-gray-800">{branch.name}</h3>
                      </div>
                      <a href={branch.mapUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-blue-600 text-white px-5 py-2.5 rounded-xl font-semibold text-sm hover:bg-blue-700 transition-colors shadow-md">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
                        Get Directions
                      </a>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-sm">
                      <div className="space-y-4">
                        <div className="flex gap-4">
                          <span className="text-xl">📍</span>
                          <p className="text-gray-600 leading-relaxed font-medium">{branch.address}</p>
                        </div>
                        <div className="flex gap-4">
                          <span className="text-xl">✉️</span>
                          <a href={`mailto:${branch.email}`} className="text-blue-600 font-bold hover:underline break-all">
                            {branch.email}
                          </a>
                        </div>
                      </div>

                      <div className="space-y-5">
                        <div className="flex gap-4">
                          <span className="text-xl">📞</span>
                          <div className="flex flex-col gap-1">
                            {branch.phones.map((p, i) => (
                              <a key={i} href={`tel:${p.replace(/\s/g, '')}`} className="text-gray-800 font-bold hover:text-blue-600 transition-colors">
                                {p}
                              </a>
                            ))}
                          </div>
                        </div>
                        <div className="flex gap-4">
                          <span className="text-xl">🕒</span>
                          <div className="space-y-2">
                            {branch.timings.map((t, i) => (
                              <div key={i}>
                                <p className="text-blue-600 font-bold text-[10px] uppercase tracking-wider">{t.day}</p>
                                <p className="text-gray-700 font-semibold">{t.hours}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    {branch.extraContacts && (
                      <div className="mt-8 pt-8 border-t border-gray-100">
                        <h4 className="text-xs font-black text-gray-400 uppercase tracking-widest mb-4">Special Enquiries & Management</h4>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                          {branch.extraContacts.map((extra, idx) => (
                            <div key={idx} className="bg-gray-50 p-3 rounded-xl border border-gray-100">
                              <p className="text-[10px] font-bold text-blue-600 uppercase mb-1">{extra.label}</p>
                              <p className="text-sm font-bold text-gray-800">
                                {extra.name && <span className="text-gray-500 font-normal">{extra.name}: </span>}
                                {extra.phone}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}

              {/* Hospital Summary Card */}
              <div className="bg-gradient-to-br from-gray-900 to-blue-900 rounded-[2rem] p-8 md:p-12 text-white flex flex-col md:flex-row justify-between items-center gap-8">
                <div className="text-center md:text-left">
                  <h4 className="text-3xl font-bold mb-2">Hospital Network</h4>
                  <p className="text-blue-200 text-lg">Quality dental care available across 4 major hubs.</p>
                  <p className="text-blue-300 text-sm mt-2 font-medium italic">* Emergency services available 24/7 at selected branches.</p>
                </div>
                <div className="h-20 w-px bg-white/20 hidden md:block"></div>
                <div className="text-center">
                  <p className="text-sm uppercase tracking-widest text-blue-300 mb-1">Total Branches</p>
                  <p className="text-5xl font-black">04</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;